import React from 'react'
import PropTypes from 'prop-types'
import { paddingSizes } from 'theme/default'
import Component from 'decorators/Component'
import Flex from 'components/Flex'
import SearchInput from 'components/SearchInput'
import Dropdown from 'components/Dropdown'
import { SearchDropdownContainer, SearchResultItem, InputField } from './Elements'

class AddressSearchInput extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    setFieldError: PropTypes.func,
    setFieldTouched: PropTypes.func,
    onReset: PropTypes.func,
    onSearchResultSelected: PropTypes.func,
    validator: PropTypes.func,
    withError: PropTypes.bool,
    MapServiceLogo: PropTypes.element,
    Container: PropTypes.element,
    LabelComponent: PropTypes.element
  }

  static defaultProps = {
    searchApi: () => {},
    name: 'address',
    debounceDuration: 700,
    onChange: () => {},
    onSearchResultSelected: () => {},
    setFieldError: () => {},
    setFieldTouched: () => {},
    onReset: () => {}
  }

  onReset = (e) => {
    const { name, setFieldError, setFieldTouched, onReset } = this.props
    setFieldError(name, undefined)
    setFieldTouched(name, false, true)
    onReset()
  }

  onSearchResultSelected = (searchState) => {
    this.props.onSearchResultSelected(searchState)
    this.validate(searchState)
  }

  validate = async ({ selected }) => {
    const { validator, name, setFieldError, setFieldTouched } = this.props
    setFieldTouched(name, true)
    if (validator) {
      const { valid, message } = await validator(selected)
      if (!valid) setFieldError(name, message)
      else setFieldError(name, null)
    }
  }

  renderSearchInput = ({ searchResults, getInputProps, selected, getDropdownProps, getResultItemProps }) => {
    const { t, name, className, label, withError, MapServiceLogo, Container, LabelComponent } = this.props
    return (
      <Dropdown
        {...getDropdownProps()}
        DropdownContainer={SearchDropdownContainer}
        renderLabel={() => (
          <InputField
            name={name}
            className={className}
            label={label || t('Search by postal code or street address')} // Put default placeholder here to make script be able extract translation message
            withError={withError}
            Container={Container}
            LabelComponent={LabelComponent}
            disableAutocomplete
            {...getInputProps()}
          />
        )}
        renderDropdown={() => (
          <React.Fragment>
            {searchResults.length === 0
              ? <SearchResultItem value={t('No results found')} withoutPointer />
              : searchResults.map(
                (result, index) => (
                  <SearchResultItem
                    key={index}
                    {...getResultItemProps(result, index)}
                  />
                )
              )}
            {MapServiceLogo && (
              <Flex width='100%' padding={paddingSizes.medium} justifyContent='flex-end'>
                {MapServiceLogo}
              </Flex>
            )}
          </React.Fragment>
        )}
      />
    )
  }

  render () {
    const { children, ...props } = this.props
    return (
      <SearchInput
        {...props}
        onReset={this.onReset}
        onSearchResultSelected={this.onSearchResultSelected}
      >
        {(searchInputProps) => children({
          ...searchInputProps,
          renderSearchInput: () => this.renderSearchInput(searchInputProps)
        })}
      </SearchInput>
    )
  }
}

export default Component()(AddressSearchInput)
